import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import * as actions from '../actions';
import {
  UpdateArtist,
  UpdateArtistSuccess,
  UpdateArtistError,
} from '../action-creators';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as artists from '@webapp/sdk/artists';
import { ArtistPlatforms } from '@common/types/artist/artist-platforms';
import SimpleArtist from '../../../../../../common/types/artist/simple-artist';
import { ArtistPlatformRecord } from '@common/types/artist/simple-artist';
import { artistDeletedEvent } from '@webapp/utils/rudderstack/events';
import AppState from '@webapp/store/state';

export const updateArtistEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, UpdateArtist>(actions.UPDATE_ARTIST),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      const cleanArtist: SimpleArtist = {
        ...action.artist,
        platforms: Object.keys(action.artist.platforms || {})
          .filter(
            (key) =>
              action.artist.platforms &&
              !!action.artist.platforms[key as ArtistPlatforms]
          )
          .reduce((memo, key) => {
            if (action.artist.platforms) {
              memo[key as ArtistPlatforms] =
                action.artist.platforms[key as ArtistPlatforms];
            }
            return memo;
          }, {} as ArtistPlatformRecord),
      };

      try {
        const updatedArtist = await artists.update(cleanArtist);

        if (!updatedArtist.isActive && !updatedArtist.enabled) {
          const social = state.tracpage.artistPage.data.social;
          const artistTracPage = state.tracpage.artistPage;

          await artistDeletedEvent({
            artist_id: updatedArtist.id,
            artist_name: updatedArtist.name,
            tracpage_domain: updatedArtist.domain,
            custom_domain: artistTracPage?.subdomain,
            streaming_profiles: updatedArtist.externalIds
              ? Object.keys(updatedArtist.externalIds).map((externalId) => ({
                  name: updatedArtist.externalIds
                    ? updatedArtist.externalIds[externalId]
                    : '',
                }))
              : [],
            social_profiles: social
              ? social.map((social) => ({
                  name: social.provider,
                  profile_url: social.url,
                }))
              : [],
            artist_deleted: true,
          });
        }

        return new UpdateArtistSuccess(updatedArtist);
      } catch (err) {
        return new UpdateArtistError(err.message);
      }
    })
  );
